// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/navbar";
import Footer from "./components/footer";

/* pages */
import Home from "./pages/home";

/* PUF PANELS */
import PufPanelsOverview, {
  PufPanelsSpecs,
  PufPanelsProjects,
} from "./pages/pufpanels";

/* FALSE CEILINGS */
import FalseCeilingsOverview, {
  FalseCeilingsSpecs,
  FalseCeilingsProjects,
} from "./pages/falseceilings";

/* RAISED FLOORING */
import RaisedFlooringOverview, {
  RaisedFlooringSpecs,
  RaisedFlooringProjects,
} from "./pages/raisedflooring";

/* CLEAN ROOMS */
import CleanRoomsOverview, {
  CleanRoomsSpecs,
  CleanRoomsProjects,
} from "./pages/cleanrooms";

/* SAFETY BARRIERS */
import SafetyBarriersOverview, {
  SafetyBarriersSpecs,
  SafetyBarriersProjects,
} from "./pages/safetybarriers";

/* DGU WINDOWS (acoustic.jsx) */
import DguWindowsOverview, {
  DguWindowsSpecs,
  DguWindowsProjects,
} from "./pages/acoustic";

/* CONTACT PAGE */
import Contact from "./pages/contact";
// (About page is optional now since you removed it from the navbar)

function App() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          {/* HOME */}
          <Route path="/" element={<Home />} />

          {/* PUF PANELS */}
          <Route path="/puf-panels" element={<PufPanelsOverview />} />
          <Route
            path="/puf-panels/specifications"
            element={<PufPanelsSpecs />}
          />
          <Route path="/puf-panels/projects" element={<PufPanelsProjects />} />

          {/* FALSE CEILINGS */}
          <Route
            path="/false-ceilings"
            element={<FalseCeilingsOverview />}
          />
          <Route
            path="/false-ceilings/specifications"
            element={<FalseCeilingsSpecs />}
          />
          <Route
            path="/false-ceilings/projects"
            element={<FalseCeilingsProjects />}
          />

          {/* RAISED FLOORING */}
          <Route
            path="/raised-flooring"
            element={<RaisedFlooringOverview />}
          />
          <Route
            path="/raised-flooring/specifications"
            element={<RaisedFlooringSpecs />}
          />
          <Route
            path="/raised-flooring/projects"
            element={<RaisedFlooringProjects />}
          />

          {/* CLEAN ROOMS */}
          <Route path="/clean-rooms" element={<CleanRoomsOverview />} />
          <Route
            path="/clean-rooms/specifications"
            element={<CleanRoomsSpecs />}
          />
          <Route
            path="/clean-rooms/projects"
            element={<CleanRoomsProjects />}
          />

          {/* SAFETY BARRIERS */}
          <Route
            path="/safety-barriers"
            element={<SafetyBarriersOverview />}
          />
          <Route
            path="/safety-barriers/specifications"
            element={<SafetyBarriersSpecs />}
          />
          <Route
            path="/safety-barriers/projects"
            element={<SafetyBarriersProjects />}
          />

          {/* DGU WINDOWS (acoustic windows & doors route) */}
          <Route
            path="/acoustic-windows-doors"
            element={<DguWindowsOverview />}
          />
          <Route
            path="/acoustic-windows-doors/specifications"
            element={<DguWindowsSpecs />}
          />
          <Route
            path="/acoustic-windows-doors/projects"
            element={<DguWindowsProjects />}
          />

          {/* CONTACT */}
          <Route path="/contact" element={<Contact />} />

          {/* fallback (optional) */}
          {/* <Route path="*" element={<Home />} /> */}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
